import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

const PREFERRED_FIRST_NAME_MAX_LENGTH = 30;

export const PREFERRED_FIRST_NAME_SCHEMA_FIELD_NAME = "preferredFirstName";

export const getPreferredFirstNameFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .max(PREFERRED_FIRST_NAME_MAX_LENGTH)
    .alphaSpace()
    .label(i18n("PreferredFirstNameFormField__LABEL").toLowerCase());
